import React, { useState, useEffect } from "react";
import SalaryPaymentModal from "./SalaryPaymentModal";
import SalarySlipModal from "./SalarySlipModal";
import "../styles/SalaryManagement.css";
import API_URL from "../apiConfig";

export default function SalaryManagement({ token, user }) {
  const [salaries, setSalaries] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showSlip, setShowSlip] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSalaries = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${API_URL}/api/salary_expense`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          setSalaries(Array.isArray(data) ? data : []);
        } else {
          setError("Unable to load salaries.");
        }
      } catch (err) {
        setError("Unable to connect to server.");
      }
      setLoading(false);
    };
    fetchSalaries();
  }, [token, showModal]);

  return (
    <div className="salary-mgmt-container">
      <h2>Manage Salaries</h2>
      <button onClick={() => setShowModal(true)} className="salary-add-btn">+ Process Salary</button>
      {loading ? (
        <div className="salary-loading">Loading...</div>
      ) : error ? (
        <div className="salary-error">{error}</div>
      ) : salaries.length === 0 ? (
        <div className="salary-empty">No salary records found.</div>
      ) : (
        <table className="salary-table">
          <thead>
            <tr>
              <th>Voucher No</th>
              <th>Staff</th>
              <th>Month</th>
              <th>Year</th>
              <th>Net Pay</th>
              <th>Mode</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {salaries.map(s => (
              <tr key={s.id}>
                <td>{s.voucher_no}</td>
                <td>{s.name}</td>
                <td>{s.month}</td>
                <td>{s.year}</td>
                <td>₹{Number(s.net_pay).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
                <td>{s.mode}</td>
                <td>
                  <button onClick={() => { setSelectedPayment(s); setShowSlip(true); }}>Slip</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {showModal && <SalaryPaymentModal token={token} user={user} onClose={() => setShowModal(false)} />}
      {showSlip && <SalarySlipModal token={token} payment={selectedPayment} onClose={() => setShowSlip(false)} />}
    </div>
  );
}